import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import ProfileDesktop from '../components/faraaz/ProfileDesktop'
import ProfileMobile from '../components/faraaz/ProfileMobile'
import AnamImg from '../assets/images/Anam.png'

const Anam = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
                <meta charSet="utf-8" />
                <title>Anam - 800 Homes</title>
            </Helmet>

            <section id="website-responsive" className="d-none d-md-block">
                <ProfileDesktop
                    Image={AnamImg}
                    Title="Anam Khan"
                    Designation="Property Consultant"
                    PhoneNumberLink="+971561367440"
                    PhoneNumber="+971 56 136 7440"
                    WhatsappLink="971561367440"
                    Whatsapp="+971 56 136 7440"
                    Email="anam@800homes.ae"
                />
            </section>

            <section id="website-responsive" className="d-block d-md-none">
                <ProfileMobile
                    Image={AnamImg}
                    Title="Anam Khan"
                    Designation="Property Consultant"
                    PhoneNumberLink="+971561367440"
                    PhoneNumber="+971 56 136 7440"
                    WhatsappLink="971561367440"
                    Whatsapp="+971 56 136 7440"
                    Email="anam@800homes.ae"
                />
            </section>
        </>
    )
}

export default Anam
